<template>
  <div
    class="home-collab-views-skeleton d-flex flex-column align-start justify-start"
    :class="{ 'is-admin-on': isAdminOn, 'is-not-admin-role': !isAdminRole }"
  >
    <div class="d-flex align-center justify-end tabs-loader">
      <v-skeleton-loader
        type="image"
        width="115px"
        height="48px"
        class="mr-1"
      />
      <v-skeleton-loader
        type="image"
        width="152px"
        height="48px"
        class="mr-1"
      />
    </div>
    <div class="d-flex flex-column align-start justify-start mt-1 tab-items-loader">
      <v-skeleton-loader
        type="image"
        width="380px"
        height="162px"
        class="mb-1"
      />
      <v-skeleton-loader
        type="image"
        width="380px"
        height="162px"
        class="mb-1"
      />
      <v-skeleton-loader
        type="image"
        width="380px"
        height="162px"
        class="mb-1"
      />
      <v-skeleton-loader
        type="image"
        width="380px"
        height="162px"
        class="mb-1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCollaborateAndRecentViewsSkeletonLoader',
  props: {
    isAdminOn: {
      type: Boolean,
      default: false,
    },
    isAdminRole: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.home-collab-views-skeleton {
  margin-top: 53px;
  height: calc(100% - 200px);
  width: 380px;

  &.is-admin-on {
    margin-top: 117px;
  }

  &.is-not-admin-role {
    margin-top: 144px;
  }
}

.full-width {
  width: 100%;
}

:deep(.v-skeleton-loader__image) {
  border-radius: 4px;
}

.tabs-loader {
  :deep(.v-skeleton-loader__image) {
    height: 48px;
  }
}

.tab-items-loader {
  :deep(.v-skeleton-loader__image) {
    height: 162px;
  }
}
</style>
